'use strict';

import FastClick from 'angular-fastclick/dist';

export default angular.module('tableTools', [])

.directive('ngRightClick', function ($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    };
})

.directive('deselectClick', function ($document) {
    function esconderPopovers() {
        $('div.popover, div.popoverFilter').each(function(index,elem){
            if(!$(elem).hasClass('popover--hidden')){
                $(elem).toggleClass('popover--hidden');
            }
        });
    }
    return {
        restrict: 'A',
        link: function (scope, elem, attr, parentCtrl) {
            elem.bind('click', function (e) {
                e.stopPropagation();
                //esconderPopovers();
            });

            var deselectHandler = function () {
                /*var theads = document.getElementsByTagName('thead');
                for (var i = 0; i < theads.length; i++) {
                    theads[i].style.display = '';
                }*/

                //$('.table-header-actions, .actionsHeader').css('display','none');

                scope.$apply(attr.deselectClick);
            };

            $document.bind('click', deselectHandler);

            $document.bind('touchstart', deselectHandler);

            scope.$on('$destroy', function(){
                $document.unbind('click', deselectHandler);
                $document.unbind('touchstart', deselectHandler);
            });
        }
    };
})


// DIRECTIVA PARA TABLE <HEAD> STICKY
// Se tiene que crear una clase en CSS que defina el estilo que va a tener
// el header de la tabla cuando se haga sticky. La clase debe definir minimo
// las siguientes reglas:
//
//      position:fixed;
//      top:0;
//
// Por lo general se va a necesitar definir el width de cada <th> dentro del header
// para que no cambie el tamaño del header.
//
// - Para utilizar la directiva se pone el atributo sticky-header="claseCSS",
//   donde "claseCSS" es la clase que se define para cuando el thead sea sticky.
//
//   Ej.
//      <table sticky-header="floating-header">
//
// - Si se tienen 2 tablas en la misma pagina se va a requerir utilizar el atributo
//   sticky-head-sel="idTabla", donde "idTabla" es el id de la tabla a la que va a tener
//   el sticky header
//
//   Ej.
//      <table id="tabla1" sticky-header="floating-header" sticky-head-sel="tabla1">
//

.directive('stickyHead', function ($document, $timeout) {
    return function (scope, element, attrs) {

        var idSelec = (!angular.isUndefined(attrs.stickyHeadSel)) ? ('#' + attrs.stickyHeadSel) : '';
        var tableClassSelector = ($('.table.tabla-normal').length >= 1) ? '.table.tabla-normal' : '.listTable';      
        var headerActions = ($('.table-header-actions').length >= 1) ? $('.table-header-actions') : $('.actionsHeader');

        var stickyHeadHandler = function () {

          $timeout(function () {
            var table = $(tableClassSelector + idSelec);
                var header = $(tableClassSelector + idSelec + ' thead');
                var offsetTop = $(document).scrollTop();
                var tableTop = table.offset() ? table.offset().top : 0;
                var classToToggle = attrs.stickyHead;

                 if (offsetTop >= tableTop) {
                    headerActions.addClass(classToToggle);
                    //$('.table.tabla-normal tr').addClass("fix");
                    //header.addClass(classToToggle);    
                    //header.hide();
                }
                else {
                    headerActions.removeClass(classToToggle);
                    //$('.table.tabla-normal td.saldo, .table.tabla-normal tr').removeClass("fix");
                    //header.removeClass(classToToggle);      
                    //header.show();
                }
            }, 100);
        };

        angular.element($document).bind('scroll', stickyHeadHandler);

        scope.$on('$destroy', function(){
            angular.element($document).unbind('scroll', stickyHeadHandler);
        });
        
    };
})
.directive("floatTableHead", ["$window", "$timeout", ($window, $timeout) => {
    const window = angular.element($window);
    return (scope, element, attrs) => {
        let centerReport = attrs.floatTableHead == 'center';
        element.floatThead();
        const resizeHandler = e => {
            if (centerReport) {
                let marginLeft = (element.width() / 2) * -1;
                if (element.width() <= element.parent().width() || element.width() > window.width()) {
                    element.css({
                        left: 0,
                        marginLeft: 0
                    });
                } else {
                    element.css({
                        left: "50%",
                        marginLeft: marginLeft
                    });
                }
            }
            return element.floatThead("reflow");
        };

        if (centerReport) {
            window.on("resize", resizeHandler);
        }
        
        scope.$on("$destroy", () => {
            window.off("resize", resizeHandler);
            element.floatThead("destroy");
        });
        scope.$on("floatThead-reflow", () => {
            $timeout(() => {
                element.floatThead("reflow");
            }, 10);
        });
    };
}])
.directive('tableRowTouch', function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            FastClick.attach(elem[0]);
        }
    };
})

.directive('actionHeader', function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            $('.actionsHeader').bind('touchstart', function (e) {
                e.stopPropagation();
            });
            $('.actionsHeader').bind('click', function (e) {
                e.stopPropagation();
            });

            elem.bind('click', function (e) {
                /*var tableHeaderId = (!angular.isUndefined(attr.actionHeaderId) && (attr.actionHeaderId !== '')) ? ('#' + attr.actionHeaderId) : '';
                var idSelec = (!angular.isUndefined(attr.actionHeader) && (attr.actionHeader !== "")) ? ('#' + attr.actionHeader) : '';
                var header = $('.listTable' + idSelec + ' thead')[0];
                if (header.className.indexOf('sticky') <= -1) {
                    header.style.display = 'none';
                }

                $('.actionsHeader' + tableHeaderId).css('display', 'block');*/
            });
        }
    };
})

.directive('displayInvalid', function ($parse, $filter) {

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elm, attrs, model) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue, scope) {
                if(model.$modelValue)
                {
                    elm.val(model.$modelValue);
                }
            });
        }
    };
})
.directive('isNumber', function ($filter) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, model) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                if (newValue) {
                    
                    var arr = String(newValue).split("");
                    if (isNaN(newValue)) {
                        newValue = newValue.replace(/[^0-9.]/g, '');
                        if(newValue.split('.').length-1 > 1 && newValue[newValue.length-1] === '.')
                        {
                            newValue = newValue.slice(0,-1);
                        }
                        model.$setViewValue(parseFloat(newValue));
                        model.$render();
                    }
                }
            });
        }
    };
})
.directive('isCurrency', function ($filter) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, model) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                if (newValue) {
                    
                    var arr = String(newValue).split("");
                    if (isNaN(newValue)) {
                        if(newValue == "-"){

                        }else{
                            newValue = newValue.replace(/^-?\d+(\.\d+)?$/g, '');
                            if(newValue.split('.').length-1 > 1 && newValue[newValue.length-1] === '.')
                            {
                                newValue = newValue.slice(0,-1);
                            }
                            model.$setViewValue(parseFloat(newValue));
                            model.$render();
                        }

                        
                    }
                }
            });
        }
    };
})
.directive('isInteger', function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, model) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                if (newValue) {
                    if (isNaN(newValue) || newValue.indexOf('.')) {
                        elem.val(newValue.replace(/[^0-9]/g, ''));
                    }
                }
            });
        }
    };
})
.directive('ngBlur', function() {
  return function( scope, elem, attrs ) {
    elem.bind('blur', function() {
        scope.$apply(attrs.ngBlur);
    });
  };
    }).directive('ngEnter', function () {
        return function (scope, element, attrs, ctrls) {
            element.bind("focus", function (event) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });
                var tabIndex = attrs.tabindex;
                $('input[tabindex=' + tabIndex + '],select[tabindex=' + tabIndex + ']').focus();
                event.preventDefault();
            });
        };
    })/*.directive('ngBlur', function () {
        return function (scope, element, attrs, ctrls) {
            element.bind("blur", function (event) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngBlur);
                });
                event.preventDefault();
            });
        };
    })*/.filter('cut', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace != -1) {
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    })
